import { Component } from 'react';
import ListGroup from 'react-bootstrap/ListGroup';
import SearchResultItems from '../components/SearchResultItems';
import { connect } from 'react-redux';
import Row from 'react-bootstrap/Row';
import EventAPI from '../api/EventAPI';
import ZoneAPI from '../api/ZoneAPI';
import SearchAPI from '../api/SearchAPI'
import Header from '../components/Header'
import Layout from '../components/Layout'
import { consoleLog } from '../managers/Logger'
import { setZone } from '../store'
import Form from 'react-bootstrap/Form'
import UtilsManager from '../managers/UtilsManager';
import { Spinner } from 'react-bootstrap';
import { canoc } from '../managers/Utils';
import DownloadPlug from '../components/DownloadPlug';
import Container from 'react-bootstrap/Container'

type Props = {
    search: string;
    domain: string;
    zone: any;
    slug:any, 
    dispatch: any, 
    events: any[], 
    tags: string[],
    zoneResp: any,
    offset: number, 
    usesSearchApi: boolean, 
    page: number,
    city: string,
    userAgent: string
};

type State = {
  search: string;
  events: any[];
  limit: number;
  offset: number;
  showViewMore: boolean, 
  zone: any, 
  allZones: any[], 
  loading: boolean
};

class Search extends Component<Props, State> {
  private eventApi: EventAPI;
  private zoneApi: ZoneAPI;
  private utilsManager: UtilsManager;

  constructor(props) {
    super(props);
    this.eventApi = new EventAPI(props.auth);
    this.zoneApi = new ZoneAPI(props.auth);
    this.utilsManager = new UtilsManager();
    this.state = {
      search: props.search,
      events: props.events,
      limit: 20,
      offset: 0,
      showViewMore: true, 
      zone: this.props.zoneResp, 
      loading: false,
      allZones: []
    };
  }

  static async getInitialProps(ctx) { 
    const zoneApi  = new ZoneAPI();
    const searchApi = new SearchAPI();
    const eventApi = new EventAPI();

    const searchTerm = ctx.query.q;
    const zoneSlug = ctx.query.city;
    var page = ctx.query.page ? ctx.query.page : 1;
    const offset = ctx.query.offset;

    var tags = ctx.query.tags;
    if (tags){
      tags = tags.split(",");
    }

    const type = ctx.query.type;

    var events = []
    var zone = null;
    if (zoneSlug) { 
      var zoneResp = await zoneApi.getZone(zoneSlug);
      if (zoneResp && zoneResp.code !== -1) {
        zone = zoneResp; 
      }
    }
    var usesSearchApi = false;
    if (tags) { 
      const eventsResp = await searchApi.search(zoneSlug, {tags: tags});
      if (eventsResp && eventsResp.code !== -1) { 
        events = eventsResp.results;
        events = events.map((item, index) => item.event)
        usesSearchApi = true;
      }
    } else { 
      if (page === 1) { 
        page = 0
      }
      console.log(page)
      const limit = ctx.query.limit ? ctx.query.limit : 20
      const eventsResult = await eventApi.getUpcomingEvents(!zoneSlug ? 'default' : zoneSlug, {
        limit: limit,
        offset: page * limit,
        search: ctx.query.search,
      });
  
      if (eventsResult && eventsResult.code !== -1) {
        events = eventsResult;
      }
    }
    return {events: events, tags: tags, zoneResp: zone, offset: offset, usesSearchApi: usesSearchApi, page: parseInt(page), city: zoneSlug}
  }

  async componentDidMount() {
    var zoneSlug = ""
    if (!this.state.zone) { 
      var zone = this.props.zoneResp
      if (!zone) { 
        zone = JSON.parse(window.sessionStorage.getItem('zone'))
      }
      if (zone) { 
        zoneSlug = zone.slug
        this.props.dispatch(setZone(zone))
        this.setState({zone: zone})
      }
    } else { 
      zoneSlug = this.state.zone.slug
    }
    window.scrollTo(0, 0);
    // if (this.props.events.length == 0) { 
    //   await this.getEventDetails(zoneSlug);
    // }

    this.zoneApi.getAllZones().then( data => {
      if (data && data.code !== -1) { 
        this.setState({allZones: data});
      }
    })
  }

  getEventDetails = async (slug, concat: boolean = false) => {
    const eventsResult = await this.eventApi.getUpcomingEvents(!slug ? 'default' : slug, {
      limit: this.state.limit,
      offset: this.props.offset ? this.props.offset : this.state.events.length,
      search: this.props.search,
    });

    consoleLog("Search response is");
    consoleLog(eventsResult);

    if (eventsResult && eventsResult.code !== -1) {
      if (eventsResult.length === 0) { 
        this.setState({showViewMore: false});
      } else { 
        this.setState({showViewMore: true});
      }
      if (concat) { 
        var currentEvents = this.state.events;
        const finalEvents = currentEvents.concat(eventsResult); 
        this.setState({events: finalEvents});
      } else { 
        this.setState({events: eventsResult})
      }
    }
  };

  handleViewMoreClicked() { 
    
  }
  

  componentDidUpdate(prevProps) {
    if (prevProps.search !== this.props.search) {
      this.getEventDetails(this.state.zone.slug);
    }
  }

  getSearchTitle() { 
    if (this.props.tags) { 
      return this.utilsManager.capitalizeFirstLetter(this.props.tags[0]) + " events";
    }
    if (!this.props.search) { 
      return "Events"
    } else { 
      return "Events matching " + this.props.search
    }
  }

  handleZonePickerChange(e) {
    const slug = e.target.value;
    window.location.href = "/search/" + slug
    // this.getEventDetails(slug)
  }

  getHeaderTitle() { 
    if (this.props.tags && this.props.tags.length > 0) { 
      const message = "ETA - " + this.utilsManager.capitalizeFirstLetter(this.props.tags[0]) + " events in " + this.props.zoneResp.name + " for black millennials";
      return message;
    }
    if (this.props.zoneResp !== null) { 
      return "ETA - Upcoming hip hop, afrobeat and black events in " + this.props.zoneResp.name;
    }
    return "ETA - Upcoming hip hop, afrobeat and black events curated by locals";
  }

  getHeaderBody() { 
    if (this.props.tags && this.props.tags.length > 0) { 
      return `Helping you find the best ${this.utilsManager.capitalizeFirstLetter(this.props.tags[0])} events and experiences in ${this.props.zoneResp.name}. Curated by for black millenials` 
    }

    if (this.props.zoneResp !== null) { 
      return "The best in hop hop, afrobeat and events for the culture in " + this.props.zoneResp.name;
    }

    return "The best in hop hop, afrobeat and events for the culture hand picked and curated by locals";
  }

  getCanonicalUrl() { 
    var url = `https://www.witheta.com/search`    
    if (this.props.zoneResp) { 
      url += `/${this.props.zoneResp.slug}`
    }

    const params = []

    if (this.props.page) { 
      url += `?page=${this.props.page}`
    }
    if (this.props.tags) { 
      url += "&tags=" + this.props.tags.toString()
    }
    return url;
  }
    
  render() {
    return (
      <Layout overrideStyle={{backgroundColor: 'white'}} title={this.getHeaderTitle()} description={this.getHeaderBody()} showHeaderSearch useHeaderContainer
      canonicalUrl={this.getCanonicalUrl()} noContainer>
        <DownloadPlug simple id="search"></DownloadPlug>
        <Container>
        <div style={{ display: 'block', marginTop: '40px' }}>
          <div>
          <h2 style={{fontSize: '50px'}}>{this.getSearchTitle()}</h2>
          <div style={{display: 'flex'}}>
            <div style={{marginRight: '10px', paddingTop: '10px'}}>
              <p>in</p>
            </div>
            <Form style={{width: '100px'}} onChange={(e) => this.handleZonePickerChange(e)}>
            <Form.Group controlId="exampleForm.ControlSelect2">
              <Form.Control as="select"> 
                {!this.state.zone && <option>online</option>}
                {this.state.zone && <option>{this.state.zone.slug}</option>}
                {this.state.allZones.map((item, index) => 
                <option>{item.slug}</option>)}
              </Form.Control>
            </Form.Group>
            </Form>
           </div>
            <div style={{ marginTop: '20px' }}>
              <ListGroup>
                <>
                  {this.props.events.length === 0 && <div>No events found. Try something else 🔍</div>                }

                    {this.props.events.map((event) => {
                      return (
                        <SearchResultItems userAgent={this.props.userAgent} eventData={event} key={event.id} onClick={() => window.location.href = `/event/${canoc(event.title, event.id)}`}/>
                      );
                    })}
                  </>
                {this.state.loading && <Spinner animation='border'></Spinner>}
              </ListGroup>

              {this.state.showViewMore && !this.state.loading && this.state.events.length === 20 &&  <Row style={{ justifyContent: 'center', alignItems: 'center'}}>
              <a href={"/search/" + this.state.zone.slug +  "?page=" + (this.props.page + 1)}>
               <div style={{backgroundColor: '#FFFFFF', border: '1px solid #000000', borderRadius: '40px', marginTop: '15px', cursor: 'pointer'
                  }}>
                  <p style={{textAlign: 'center', fontWeight: 'normal', fontSize: '18px', letterSpacing: '0.75px', color: '#000000', marginBottom: '0', 
                    padding: '10px 15px',
                    }}
                  >
                    Next page
                  </p>
                </div></a>
              </Row>}
            </div>
          </div>
        </div>
        </Container>
        <style jsx global>{`
				.h1, .h2, .h3, .h4, h1, h2, h3, h4{ 
					font-family: 'Nerko One', sans-serif !important;
					font-stye: normal;
					font-weight: normal !important;
					letter-spacing: 1px !important;
        }`}
        </style>
      </Layout>
    );
  }
}

export default connect((state) => state)(Search);
